module.exports = __webpack_public_path__ + "img/interface-dark.09793192.svg";